<template>
  <div class="map_box">
    <!-- <nColorBarGD
      :min.sync="min"
      :max.sync="max"
      :dataType="draw_options.sensortype"
      :colorType.sync="tileSty"
      :option="{ colorType: true, optBtn: false, advanced: { barType: true } }"
    >
    </nColorBarGD> -->

    <base-map
      @map="initMap"
      :zoom="zoom"
      height="100%"
      width="auto"
      :month="month"
      :map-id="main_map"
      :sensortype="draw_options.sensortype"
      :colorType="colorType"
      :isOpsShow="true"
    ></base-map>

    <transition-panel>
      <a-spin :spinning="spinning" slot="content">
        <div style="margin-top: 16px;display: flex;">
          图层显示：
          <div>
            <a-checkbox v-model="wzShow">微站</a-checkbox>
            <a-checkbox
              v-model="patrolDeviceShow"
              v-if="userMenuPower.controls.showPatrolList"
              >巡查设备</a-checkbox
            >
            <a-checkbox v-model="showStationName">显示站点名称</a-checkbox>
            <a-checkbox v-model="showNoDataStation">显示未上线设备</a-checkbox>
            <div
              style="margin-top: 12px"
              v-if="!userMenuPower.controls.isHideGfStation"
            >
              <a-checkbox v-model="gfShow">标站</a-checkbox>
              <a-select
                :disabled="!gfShow"
                v-model="gfLevelList"
                mode="multiple"
                size="small"
                style="width: 240px;"
              >
                <a-select-option
                  v-for="value in gfLevelOptions"
                  :key="value"
                  :value="value"
                  >{{ value + "控" }}</a-select-option
                >
              </a-select>
            </div>
          </div>
        </div>
        <div style="margin-top: 16px">
          参数显示：
          <a-radio-group
            v-model="draw_options.sensortype"
            size="small"
            button-style="solid"
          >
            <a-radio-button
              :value="item.value"
              v-for="item in sensortypes"
              :key="item.value"
              >{{ item.label }}</a-radio-button
            >
          </a-radio-group>
        </div>
        <div style="margin-top: 16px">
          时间类型：
          <a-radio-group
            v-model="timeType"
            size="small"
            button-style="solid"
            :disabled="activeKey != '1'"
          >
            <a-radio-button
              :value="item.value"
              v-for="item in timeTypes"
              :key="item.value"
              >{{ item.label }}</a-radio-button
            >
          </a-radio-group>
          <!-- &nbsp;&nbsp;
          <a-checkbox v-model="showCurrent">
            显示当前
          </a-checkbox>
          <a-date-picker
            :disabled="showCurrent"
            v-model="time"
            size="small"
            :format="
              timeType == 'sec'
                ? 'YYYY-MM-DD HH:mm:ss'
                : timeType == 'min'
                ? 'YYYY-MM-DD HH:mm'
                : timeType == 'hour'
                ? 'YYYY-MM-DD HH'
                : 'YYYY-MM-DD'
            "
            :disabledDate="disabledDate"
            :show-time="
              ['sec', 'min', 'hour'].includes(timeType) ? true : false
            "
          /> -->
        </div>
        <a-tabs v-model="activeKey">
          <a-tab-pane key="1" tab="微站">
            <div style="padding-bottom: 10px">
              <a-input
                v-model="nameSearch"
                placeholder="请输入微站名称"
                size="small"
                style="width: 150px"
              />
              &nbsp;&nbsp;<a-select
                v-model="quxianSearch"
                size="small"
                style="width: 100px;"
              >
                <a-select-option
                  v-for="value in quxianOptions"
                  :key="value"
                  :value="value"
                  >{{ value }}</a-select-option
                >
              </a-select>
              &nbsp;&nbsp;<a-button
                size="small"
                type="primary"
                @click="exportData"
                >导出数据</a-button
              >
              &nbsp;&nbsp;<a-button
                size="small"
                type="primary"
                ghost
                style="border-color: #fff;"
                @click="visible = true"
                >在线率</a-button
              >
            </div>
            <a-table
              :columns="wzColumns"
              :data-source="wzListSort"
              rowKey="station_id"
              size="small"
              :scroll="{
                x: true,
                y: 500
              }"
              :pagination="false"
              @change="handleWzTableChange"
            >
              <template slot="idx" slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
              <template slot="station_name" slot-scope="text, record">
                <a @click="viewDetail(record)">{{ text }}</a>
              </template>
              <template slot="category" slot-scope="text, record">
                <div
                  :style="{
                    background: record.water_category_info.bgcolor,
                    borderRadius: '5px',
                    padding: '4px 0',
                    width: '72px',
                    color: record.water_category_info.fgcolor
                  }"
                >
                  {{ record.water_category_info.name }}
                </div>
              </template>
              <template
                v-for="item in sensortypes"
                :slot="item.value"
                slot-scope="text, record"
              >
                <div
                  :key="item.value"
                  :style="{
                    background:
                      record.water_category_info.worst_sensortype_list &&
                      record.water_category_info.worst_sensortype_list.includes(
                        item.value
                      )
                        ? record.water_category_info.bgcolor
                        : '',
                    color:
                      record.water_category_info.worst_sensortype_list &&
                      record.water_category_info.worst_sensortype_list.includes(
                        item.value
                      )
                        ? record.water_category_info.fgcolor
                        : '',
                    padding: '4px 0',
                    width: '72px',
                    borderRadius: '5px'
                  }"
                >
                  {{ record[item.value] ?? "--" }}
                </div>
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane
            key="2"
            tab="巡查设备"
            v-if="userMenuPower.controls.showPatrolList"
          >
            <a-table
              :columns="deviceColumns"
              :data-source="patrolList"
              rowKey="station_id"
              size="small"
            >
              <template slot="idx" slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
              <template slot="station_name" slot-scope="text, record">
                <a @click="viewDetail(record)">{{ text }}</a>
              </template>
              <template slot="is_enable" slot-scope="text">
                <a-badge :status="text ? 'success' : 'default'" />
                {{ text ? "在线" : "离线" }}
              </template>
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </transition-panel>
    <online-rate :visible.sync="visible"></online-rate>
    <boat-real-video
      class="fix-video-wrapper"
      v-if="curUrl"
      ref="real_video"
      :board_id="curInfo.station_id"
      :url="curUrl"
      @close="curUrl = ''"
    ></boat-real-video>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import BaseMap from "@/components/BaseMapNew";
import TransitionPanel from "@/components/TransitionPanel";
import OnlineRate from "./components/OnlineRate";
import BoatRealVideo from "@/components/BoatRealVideo";
import {
  openWzStationWindow,
  openGfStationWindow,
  openBoatVideoWindow
} from "@/utils/open_station_window";
import { timeTypes } from "@/options/common";
import {
  getCurrentData,
  getHistoryDataCurr,
  getGfStationListData,
  getBoardVideo
} from "@/api/api";
import moment from "moment";
import _ from "lodash";
import FileSaver from "@/utils/plugins/FileSaver";
import { isCheckNumber } from "@/utils/utils";
const gfLevelOptions = ["国", "省", "市"];

export default {
  data() {
    return {
      main_map: "comprehensive_map",
      zoom: {
        value: 9,
        max: 17,
        min: 5,
        show: true
      },
      tileSty: "static_gradient",
      colorType: "static",
      map: null,
      min: 0,
      max: 1,
      group_id: null,
      activeKey: "1",
      draw_options: {
        sensortype: "pm10",
        drawtype: "point",
        drawname: false,
        showcar: false,
        mode: "realtime"
      },
      spinning: false,
      month: this.$moment().format("YYYY-MM-DD"),
      wzShow: true,
      patrolDeviceShow: false,
      showStationName: false,
      showNoDataStation: false,
      gfShow: false,
      timeTypes,
      timeType: "min",
      showCurrent: true,
      time: this.$moment()
        .subtract(10, "minutes")
        .format("YYYY-MM-DD HH:mm"),
      wzColumns: [],
      deviceColumns: [],
      wzList: [],
      wzListSort: [],
      gfList: [],
      patrolList: [],
      pointLayer: null,
      gfPointLayer: null,
      patrolDeviceLayer: null,
      chooseStation: {},
      wzTimer: null,
      patrolTimer: null,
      gfLevelOptions,
      gfLevelList: gfLevelOptions,
      quxianOptions: [],
      nameSearch: "",
      quxianSearch: "区县",
      visible: false,
      curInfo: {},
      curUrl: "",
      offlineSeconds: process.env.VUE_APP_OFFLINE_SECONDS
    };
  },
  components: {
    BaseMap,
    TransitionPanel,
    OnlineRate,
    BoatRealVideo
  },
  computed: {
    ...mapState([
      "authUserInfo",
      "userMenuPower",
      "sensortypes",
      "projectInfo",
      "colorRange"
    ]),
    ...mapGetters(["defaultInfo"]),
    intensity() {
      return new colorIntensity.getIntensity({
        dataType: this.draw_options.sensortype,
        max: this.colorRange[1],
        min: this.colorRange[0],
        colorType: this.colorType
      });
    },
    options() {
      let opts = {
        zIndex: 110,
        showValue: true,
        showTitle: this.showStationName,
        drawCircle: false,
        intensity: this.intensity,
        titleKey: "name",
        valueKey: this.draw_options.sensortype,
        icon: "",
        callback: this.clickPoint
      };
      return opts;
    },
    gfOptions() {
      let opts = {
        zIndex: 110,
        showValue: true,
        showTitle: this.showStationName,
        drawCircle: false,
        showOffline: true,
        intensity: this.intensity,
        titleKey: "station",
        valueKey: this.draw_options.sensortype,
        icon: "★",
        showChart: false,
        callback: this.clickGfPoint
      };
      return opts;
    }
  },
  watch: {
    intensity() {
      this.drawPoints();
      this.drawGfPoints();
    },
    wzShow() {
      this.drawPoints();
    },
    async gfShow(v) {
      if (v) {
        await this.getGfListData();
      }
      this.drawGfPoints();
    },
    gfLevelList() {
      this.drawGfPoints();
    },
    showNoDataStation() {
      this.drawPoints();
    },
    patrolDeviceShow() {
      this.drawPatrolDevices();
    },
    wzList: {
      handler() {
        this.wzListSort = this.wzList;
        this.drawPoints();
      },
      deep: true
    },
    gfList: {
      handler() {
        this.drawGfPoints();
      },
      deep: true
    },
    patrolList: {
      handler() {
        this.drawPatrolDevices();
      },
      deep: true
    },
    timeType() {
      this.getData();
    },
    showCurrent() {
      this.getData();
    },
    time() {
      this.getData();
    },
    activeKey() {
      this.getData();
    },
    options() {
      this.pointLayer && this.pointLayer.setOptions(this.options);
    },
    gfOptions() {
      this.gfPointLayer && this.gfPointLayer.setOptions(this.gfOptions);
    },
    nameSearch() {
      if (this.showCurrent) {
        this.getWzCurrentData();
      } else {
        this.getWzHistoryData();
      }
    },
    quxianSearch() {
      if (this.showCurrent) {
        this.getWzCurrentData();
      } else {
        this.getWzHistoryData();
      }
    }
  },
  created() {
    this.draw_options.sensortype = this.defaultInfo.defaultSensorType;
    this.group_id = this.defaultInfo.defaultGroupId;
  },
  mounted() {
    this.wzColumns = [
      {
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "idx" },
        width: 50,
        align: "center",
        fixed: "left"
      },
      {
        title: "站点名称",
        dataIndex: "station_name",
        key: "station_name",
        width: 172,
        scopedSlots: { customRender: "station_name" },
        align: "center",
        fixed: "left"
      },
      {
        title: "水质类别",
        dataIndex: "category",
        key: "category",
        width: 100,
        scopedSlots: { customRender: "category" },
        align: "center",
        fixed: "left"
      }
    ];
    this.deviceColumns = [
      {
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "idx" },
        align: "center"
      },
      {
        title: "站点名称",
        dataIndex: "station_name",
        key: "station_name",
        scopedSlots: { customRender: "station_name" },
        align: "center"
      },
      {
        title: "状态",
        dataIndex: "is_enable",
        key: "is_enable",
        scopedSlots: { customRender: "is_enable" },
        align: "center"
      }
    ];
    if (this.sensortypes.length) {
      this.sensortypes.forEach(x => {
        this.wzColumns.push({
          title: x.label,
          dataIndex: x.value,
          key: x.value,
          scopedSlots: { customRender: x.value },
          width: 90,
          align: "center",
          sorter: true
        });
        // 无人船数据去掉电导率
        if (x.value != "conductivity") {
          this.deviceColumns.push({
            title: x.label,
            dataIndex: x.value,
            key: x.value,
            scopedSlots: { customRender: x.value },
            align: "center"
          });
        }
      });
    }
    this.wzColumns = [
      ...this.wzColumns,
      {
        title: "区县",
        dataIndex: "quxian",
        key: "quxian",
        width: 100,
        align: "center"
      },
      {
        title: "所属河道",
        dataIndex: "river",
        key: "river",
        width: 80,
        align: "center"
      }
    ];
    this.getQuXianList();
    this.getData();
  },
  beforeRouteLeave(to, from, next) {
    this.clearTimer();
    next();
  },
  methods: {
    async getQuXianList() {
      try {
        let res = await getCurrentData(
          this.group_id,
          this.timeType,
          "1",
          "",
          ""
        );
        let data = res.data.data;
        let quxianOptions = [];
        // 计算水质类别
        data.forEach(item => {
          if (!quxianOptions.includes(item.quxian)) {
            quxianOptions.push(item.quxian);
          }
        });
        quxianOptions.unshift("区县");
        this.quxianOptions = quxianOptions;
      } catch (error) {
        console.log(error);
      }
    },
    getWaterCategory(item) {
      if (!this.projectInfo.sensorType) {
        return {};
      }
      let sensortypeArr = [];
      const check_sensor_types = [
        "cod",
        "ammonia_nitrogen",
        "ph",
        "dissolved_oxygen"
      ];
      this.projectInfo.sensorType.split(",").forEach(x => {
        if (check_sensor_types.includes(x)) {
          sensortypeArr.push({ name: x, value: item[x] });
        }
      });
      return colorIntensity.getWaterQualityCategory(sensortypeArr, "static");
    },
    disabledDate(current) {
      return current > this.$moment();
    },
    initMap(map) {
      this.map = map;
      this.drawPoints();
    },
    getData() {
      this.clearTimer();
      if (this.showCurrent) {
        this.getWzCurrentData();
        this.getPatrolCurrentData();
        if (this.activeKey == "1") {
          this.wzTimer = setInterval(() => {
            this.getWzCurrentData();
          }, 30000);
        } else {
          this.patrolTimer = setInterval(() => {
            this.getPatrolCurrentData();
          }, 3000);
        }
      } else {
        // this.getHistoryData();
        if (this.activeKey == "1") {
          this.getWzHistoryData();
        } else {
          this.getPatrolHistoryData();
        }
      }
    },
    clearTimer() {
      this.wzTimer && clearInterval(this.wzTimer);
      this.patrolTimer && clearInterval(this.patrolTimer);
    },
    async getWzCurrentData() {
      try {
        let res = await getCurrentData(
          this.group_id,
          this.timeType,
          "1",
          this.nameSearch,
          this.quxianSearch == "区县" ? "" : this.quxianSearch
        );
        let data = res.data.data;
        // 计算水质类别
        data.forEach(item => {
          const diffSeconds = moment().diff(moment(item.time), "seconds");
          this.sensortypes.forEach(s => {
            if (["sec", "min"].includes(this.timeType)) {
              item[s.value] =
                diffSeconds > this.offlineSeconds
                  ? "--"
                  : this.$sr(s.value, item[s.value]) || "--";
            } else {
              item[s.value] = this.$sr(s.value, item[s.value]) || "--";
            }
          });

          item.water_category_info = this.getWaterCategory(item);
        });
        this.wzList = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getGfListData() {
      try {
        const sensortypes = this.sensortypes.map(x => x.value).join(",");
        let time = moment(this.time).format("YYYY-MM-DD HH:00:00");
        let res = await getGfStationListData(
          this.projectInfo.regionId,
          sensortypes,
          this.showCurrent ? "" : time
        );
        this.gfList = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getPatrolCurrentData() {
      try {
        let res = await getCurrentData(this.group_id, "sec", "2,3");
        let data = res.data.data;
        // 判断设备不在线，根据时间判断
        data.forEach(x => {
          const diffSeconds = moment().diff(moment(x.time), "seconds");
          this.sensortypes.forEach(s => {
            x[s.value] =
              diffSeconds > this.offlineSeconds
                ? "--"
                : this.$sr(s.value, x[s.value]) || "--";
          });
        });
        this.patrolList = data;
      } catch (error) {
        console.log(error);
      }
    },
    getHistoryData() {
      this.getWzHistoryData();
      this.getPatrolHistoryData();
    },
    async getWzHistoryData() {
      try {
        let time = null;
        if (this.timeType == "sec") {
          time = moment(this.time).format("YYYY-MM-DD HH:mm:ss");
        } else if (this.timeType == "min") {
          time = moment(this.time).format("YYYY-MM-DD HH:mm:00");
        } else if (this.timeType == "hour") {
          time = moment(this.time).format("YYYY-MM-DD HH:00:00");
        } else {
          time = moment(this.time).format("YYYY-MM-DD 00:00:00");
        }
        let res = await getHistoryDataCurr(
          this.group_id,
          null,
          this.timeType,
          time,
          "1",
          this.nameSearch,
          this.quxianSearch == "区县" ? "" : this.quxianSearch
        );
        let data = res.data.data;
        // 计算水质类别
        data.forEach(item => {
          this.sensortypes.forEach(s => {
            item[s.value] = this.$sr(s.value, item[s.value]) || "--";
          });
          item.water_category_info = this.getWaterCategory(item);
        });
        this.wzList = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getPatrolHistoryData() {
      try {
        let time = moment(this.time).format("YYYY-MM-DD HH:mm:ss");
        let res = await getHistoryDataCurr(
          this.group_id,
          null,
          this.timeType,
          time,
          "2,3"
        );
        let data = res.data.data;
        data.forEach(x => {
          this.sensortypes.forEach(
            s => (x[s.value] = this.$sr(s.value, x[s.value]) || "--")
          );
        });

        this.patrolList = data;
      } catch (error) {
        console.log(error);
      }
    },
    drawPoints() {
      this.clearPoints();
      if (!this.wzShow) {
        return;
      }
      let pointMarkers = [];
      let list = this.$_.cloneDeep(this.wzList);
      for (let i of list) {
        // 去掉未上线设备
        if (
          !this.showNoDataStation &&
          !isCheckNumber(i[this.draw_options.sensortype])
        ) {
          continue;
        }
        const gcj = coordtransform.bd09togcj02(i.lng, i.lat);
        i.lng = gcj[0];
        i.lat = gcj[1];
        i.name = i.station_name;
        i[this.draw_options.sensortype] =
          i[this.draw_options.sensortype] ?? "--";

        if (i.is_trace) {
          // 溯源设备
          i.traceClass = "iconfont icon-Trace";
        } else {
          // 设备运维中(非溯源设备)
          i.operationClass = i.is_enable ? "" : "iconfont icon-Operation";
        }
        pointMarkers.push(i);
      }
      let layer = new nMapGD.StationLayer(this.map, pointMarkers, this.options);
      this.pointLayer = layer;
    },
    clearPoints() {
      this.pointLayer && this.pointLayer.destroy();
    },
    drawGfPoints() {
      this.gfPointLayer && this.gfPointLayer.destroy();
      if (!this.gfShow) {
        this.gfLevelList = gfLevelOptions;
        return;
      }
      let pointMarkers = [];
      let list = this.$_.cloneDeep(this.gfList);
      list = list.filter(item => this.gfLevelList.includes(item.station_level));
      for (let i of list) {
        i.temperature = i.water_temperature;
        // 去掉未上线设备
        if (
          !this.showNoDataStation &&
          !isCheckNumber(i[this.draw_options.sensortype])
        ) {
          continue;
        }
        const gcj = coordtransform.wgs84togcj02(i.lng, i.lat);
        i.lng = gcj[0];
        i.lat = gcj[1];
        i[this.draw_options.sensortype] =
          i[this.draw_options.sensortype] ?? "--";
        pointMarkers.push(i);
      }
      let layer = new nMapGD.StationLayer(
        this.map,
        pointMarkers,
        this.gfOptions
      );
      this.gfPointLayer = layer;
    },
    drawPatrolDevices() {
      this.clearPatrolDevices();
      if (!this.patrolDeviceShow) {
        return;
      }
      let patrolList = this.patrolList.filter(x => x.lat && x.lng);
      patrolList.forEach(x => {
        if (x.dev_type == "2") {
          x.img = "static/images/无人船.png";
        } else {
          x.img = "static/images/无人机.png";
        }
        x.width = 40;
        x.height = 52;
      });
      let opts = {
        zIndex: 10,
        drawMode: "icon",
        icon: {
          width: 40,
          height: 52,
          deg: 0
        },
        point: {
          size: 5
        },
        events: {
          click: async e => {
            if (this.showCurrent) {
              // openBoatVideoWindow(this.map, e);
              try {
                let res = await getBoardVideo(e.station_id);
                let url = res.data.flv;
                let isOnline = res.data.online;
                if (isOnline) {
                  this.curInfo = e;
                  this.curUrl = url;
                } else {
                  this.$message.warning("设备不在线");
                }
              } catch (error) {
                console.log(error);
              }
            } else {
              this.$message.warning("请在当前状态下查看");
            }
          }
        }
      };
      this.patrolDeviceLayer = new nMapGD.CanvasCommonLayer(
        this.map,
        patrolList,
        opts
      );
    },
    clearPatrolDevices() {
      this.patrolDeviceLayer && this.patrolDeviceLayer.destroy();
    },
    async viewDetail(record) {
      if (this.activeKey == "1") {
        let point = new AMap.LngLat(record.lng, record.lat);
        record.point = point;
        this.clickPoint(record);
      } else {
        if (this.showCurrent) {
          try {
            let res = await getBoardVideo(record.station_id);
            let url = res.data.flv;
            let isOnline = res.data.online;
            if (isOnline) {
              this.curInfo = record;
              this.curUrl = url;
            } else {
              this.$message.warning("设备不在线");
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          this.$message.warning("请在当前状态下查看");
        }
      }
    },
    clickPoint(e) {
      this.chooseStation = e;
      openWzStationWindow({
        group_id: this.group_id,
        map: this.map,
        point: e.point,
        station: this.chooseStation,
        timeType: this.timeType,
        dataType: this.draw_options.sensortype,
        sensor_types: this.projectInfo.sensorType
      });
    },
    clickGfPoint(e) {
      openGfStationWindow({
        map: this.map,
        sn: e.sn,
        point: e.point,
        timeType: ["sec", "min"].includes(this.timeType)
          ? "hour"
          : this.timeType,
        dataType: this.draw_options.sensortype,
        sensor_types: this.projectInfo.sensorType
      });
    },
    handleWzTableChange(pagination, filters, sorter) {
      let value = sorter.field;
      this.wzListSort = _.cloneDeep(this.wzList);
      if (sorter.order) {
        this.wzListSort = this.wzListSort.sort((a, b) => {
          if (!a[value]) {
            return 9999;
          } else if (!b[value]) {
            return -9999;
          }
          return sorter.order == "ascend"
            ? a[value] - b[value]
            : b[value] - a[value];
        });
      }
    },
    exportData() {
      const content = [];
      const senorLabelArr = this.sensortypes.map(x => x.label);
      content[0] = [
        `序号,微站名称,区县,所属河道,${senorLabelArr.join(",")},时间 \n`
      ];
      for (let [index, item] of this.wzList.entries()) {
        const textArr = [];
        for (let s of this.sensortypes) {
          textArr.push(this.$sr(s.value, item[s.value]));
        }
        const text = `${parseInt(index) + 1},${item.station_name},${
          item.quxian
        },${item.river},${textArr.join(",")}, ${item.time}\t\n`;
        content.push([text]);
      }
      var blob = new Blob(content, { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(blob, `数据${moment().format("YYYYMMDDHHmmss")}.csv`);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-body-outer {
  margin-bottom: -10px !important;
}
</style>
